import isEmpty from 'lodash/isEmpty';

import { SELECT_SEGMENT } from '../actionTypes';
import { actions } from '../reducer';

export default (segment) => (dispatch) => {
    if (isEmpty(segment)) return;
    dispatch(actions[SELECT_SEGMENT]({ ...segment, open: !segment.open }));
};
